// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s5Un","footer":"styles_footer__ih876"};